import HttpStatus from 'http-status-codes';
import { FetchHandler, JsonAPIDocument, JsonAPIError } from 'json-api-hooks';

import SignInModal from '../modals/SignInModal';

import useModalDispatch from './useModalDispatch';
import useSnackbar from './useSnackbar';

const ERROR_MESSAGES: Record<number, string> = {
  [HttpStatus.FORBIDDEN]: 'Niet toegestaan',
  [HttpStatus.NOT_FOUND]: 'Niet gevonden',
};

const useFetchErrorHandler = (): FetchHandler<unknown> => {
  const showSnackbar = useSnackbar();
  const dispatchSignInModal = useModalDispatch(SignInModal);

  return ({ json, response, url }) => {
    const firstError = ((json as JsonAPIDocument).errors ?? [])[0] as JsonAPIError | undefined;
    if (response.status === HttpStatus.UNAUTHORIZED) {
      if (!url.includes('/u/session/new')) {
        showSnackbar('Log in om door te gaan');
        dispatchSignInModal({});
      }
    } else {
      if (response.status === HttpStatus.UNPROCESSABLE_ENTITY && firstError) {
        showSnackbar(firstError.title);
      } else {
        showSnackbar(ERROR_MESSAGES[response.status] ?? 'Er ging iets mis');
      }
    }
  };
};

export default useFetchErrorHandler;
